/**
 * TODO:
 * - fix @ts-ignore
 */
// PKCE HELPER FUNCTION
// Generate a secure random string using the browser crypto functions
export const getCodeVerifier = () => {
  const array = new Uint32Array(28);
  window.crypto.getRandomValues(array);
  return base64urlencode(array);
};

export const base64urlencode = (str: ArrayBuffer) => {
  // Convert the ArrayBuffer to string using Uint8 array to conver to what btoa accepts.
  // btoa accepts chars only within ascii 0-255 and base64 encodes them.
  // Then convert the base64 encoded to base64url encoded
  //   (replace + with -, replace / with _, trim trailing =)
  // @ts-ignore
  return btoa(String.fromCharCode.apply(null, new Uint8Array(str)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

// Calculate the SHA256 hash.
// Returns a promise that resolves to an ArrayBuffer
export const sha256 = (message: string) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(message);
  return window.crypto.subtle.digest('SHA-256', data);
};

export const pkceChallengeFromVerifier = async (v: string) => {
  const hashed = await sha256(v);
  return base64urlencode(hashed);
};
